import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { HoverGradientDirective } from '../../shared/directives/hover-gradient.directive';

@Component({
  selector: 'app-join-us',
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
    HoverGradientDirective,
    RouterLink,
    RouterLink,
  ],
  templateUrl: './join-us.component.html'
})
export class JoinUsComponent {
  steps = [ 1, 2, 3, 4 ];

}
